module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingCreateuser.6db8a8da.png";